var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _path4, _circle17, _circle18, _circle19, _circle20, _path5, _path6, _path7, _path8, _circle21, _path9, _circle22, _circle23, _circle24, _path10, _path11, _circle25, _circle26, _path12, _circle27, _path13, _circle28, _path14, _circle29, _circle30, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTablets = function SvgTablets(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M493.52 61.33c1.65 7.86 1.6 15.82 1.6 23.8q-.06 229.27 0 458.53c0 28.2-13 41.27-41 41.27q-169.4 0-338.8.05a88.93 88.93 0 0 1-19.34-1.68C79.33 575.4 73 562.15 73 544q.41-232.36.16-464.74c0-27.56 13.2-40.81 40.64-40.81 113.23 0 226.47.2 339.7-.2 18.57-.11 32.01 6.12 40.02 23.08zm-33.66 250.32c0-65.08-.12-130.17.17-195.25 0-7.08-1.95-8.75-8.85-8.74q-167.29.32-334.6 0c-6.61 0-8.37 1.63-8.36 8.32q.3 195.7 0 391.4c0 6.74 1.84 8.3 8.4 8.29q167.29-.3 334.6 0c7 0 8.84-1.75 8.81-8.77-.28-65.08-.17-130.16-.17-195.25zM285.49 560.08c6.17 0 12.33.08 18.5 0 3.64-.07 6.27-1.72 6.43-5.73.19-4.48-2.5-6.42-6.59-6.45q-18-.14-36.1 0c-3.65 0-6.27 1.67-6.42 5.72-.17 4.47 2.47 6.38 6.57 6.46 5.87.1 11.74.01 17.61 0zm7-501.4c-.82-5.26-3.73-8.89-9.08-9s-9 3.32-9.18 8.65c-.18 5.79 3.5 9.47 9.27 9.4 5.38-.06 8.24-3.73 9-9.05z",
    fill: "#fefdfd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M459.86 311.65c0 65.09-.11 130.17.16 195.26 0 7-1.86 8.78-8.81 8.77q-167.31-.33-334.6 0c-6.56 0-8.41-1.55-8.4-8.29q.33-195.69 0-391.4c0-6.69 1.75-8.33 8.36-8.32q167.3.32 334.6 0c6.9 0 8.88 1.66 8.85 8.74-.28 65.07-.16 130.16-.16 195.24zM285.49 560.08c-5.87 0-11.74.1-17.61 0-4.1-.08-6.74-2-6.57-6.46.15-4.05 2.77-5.7 6.42-5.72q18-.15 36.1 0c4.09 0 6.78 2 6.59 6.45-.16 4-2.79 5.66-6.43 5.73-6.17.08-12.33 0-18.5 0zM292.5 58.68c-.76 5.28-3.62 9-9 9.06-5.77.07-9.45-3.61-9.27-9.4.17-5.33 3.83-8.75 9.18-8.65s8.27 3.73 9.09 8.99z",
    fill: "#6e5f91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M461 311.65v131.39c0 10.35-219.17-335.22-211.3-335.22 56.86 0 145.76 0 202.62-.16 6.89 0 8.88 1.66 8.85 8.74-.33 65.08-.17 130.17-.17 195.25z",
    fill: "#f4abe0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 165.12,
    cy: 163.47,
    r: 23.27,
    fill: "#f0592b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.3,
    cy: 163.47,
    r: 23.27,
    fill: "#fdb73e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.9,
    cy: 163.47,
    r: 23.27,
    fill: "#6ab4e5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.63,
    cy: 163.47,
    r: 23.27,
    fill: "#b7a2cc"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.12,
    cy: 245.09,
    r: 23.27,
    fill: "#f4abe0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.3,
    cy: 245.09,
    r: 23.27,
    fill: "#93b847"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.9,
    cy: 245.09,
    r: 23.27,
    fill: "#b7a2cc"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.63,
    cy: 245.09,
    r: 23.27,
    fill: "#f0592b"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.12,
    cy: 326.88,
    r: 23.27,
    fill: "#6ab4e5"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.3,
    cy: 326.88,
    r: 23.27,
    fill: "#f0592b"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.9,
    cy: 326.88,
    r: 23.27,
    fill: "#16a99e"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.63,
    cy: 326.88,
    r: 23.27,
    fill: "#b7a2cc"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.12,
    cy: 405.75,
    r: 23.27,
    fill: "#16a99e"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.3,
    cy: 405.75,
    r: 23.27,
    fill: "#d6842d"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.9,
    cy: 405.75,
    r: 23.27,
    fill: "#f4abe0"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.63,
    cy: 405.75,
    r: 23.27,
    fill: "#b7a2cc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7a2cc",
    d: "M116.61 515.67h334.6l-27.27-38.69H140.82l-24.21 38.69z"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.12,
    cy: 473.16,
    r: 23.27,
    fill: "#fdb73e"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.3,
    cy: 473.16,
    r: 23.27,
    fill: "#f0592b"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.9,
    cy: 473.16,
    r: 23.27,
    fill: "#6ab4e5"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.63,
    cy: 473.16,
    r: 23.27,
    fill: "#93b847"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M575.57 214.87a2.72 2.72 0 0 0 2.63-2.87 2.67 2.67 0 0 0-2.63-2.63c-2.43 0-24.28-.81-24.28-26.3a2.63 2.63 0 1 0-5.26 0c0 25.49-21.85 26.3-24.27 26.3h-.21a2.63 2.63 0 0 0-2.42 2.63 2.68 2.68 0 0 0 2.63 2.63c2.63 0 24.27.81 24.27 26.3a2.69 2.69 0 0 0 2.63 2.63 2.33 2.33 0 0 0 2.43-2.43c0-25.49 21.85-26.3 24.28-26.3z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M450.92 9.37c-120.28.42-240.56.21-360.84.21-29.15 0-43.17 14.07-43.17 43.35q0 246.84-.17 493.68c0 19.31 6.73 33.38 24.35 41.78a94.23 94.23 0 0 0 20.54 1.78q179.94-.1 359.89 0c29.78 0 43.59-13.88 43.59-43.84V59.26c0-8.48.05-16.93-1.7-25.28-8.47-18.07-22.75-24.68-42.49-24.61zM270.26 21.56c5.69.11 8.78 4 9.65 9.55-.81 5.61-3.85 9.55-9.55 9.62-6.12.08-10-3.82-9.84-10 .18-5.64 4.06-9.27 9.74-9.17zm28.69 536c-.18 4.27-3 6-6.84 6.1-6.54.12-13.09 0-19.64 0-6.24 0-12.48.1-18.71 0-4.36-.08-7.16-2.11-7-6.86.16-4.31 2.94-6.05 6.82-6.08q19.17-.15 38.35 0c4.36.05 7.22 2.11 7.07 6.87zm159.91-257.73V439.4c0 .45-.4.25-1.15-.53q0 34.19.16 68.37c0 7.46-2 9.33-9.36 9.32H93.07c-7 0-8.93-1.65-8.92-8.8q.34-207.88 0-415.77c0-7.1 1.87-8.85 8.89-8.84q85.59.17 171.19.17c36.77 0 80.19 0 120.09-.08l64.15-.09h1.16c7.33 0 9.44 1.76 9.4 9.28-.3 69.13-.17 138.27-.17 207.4z",
    fill: "#fefdfd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M373.24 316a23.77 23.77 0 0 1 .24-3.4c-13.53-21.15-27.62-43.34-41.41-65.24a24.72 24.72 0 1 1-25.8-41.22c-41.85-67.25-75.12-122.83-71.87-122.83h29.83q-85.59 0-171.19-.17c-7 0-8.9 1.74-8.89 8.84q.34 207.88 0 415.77c0 7.15 1.95 8.81 8.92 8.8l25.71-41.1h1.43a25.77 25.77 0 0 1-.33-4.06 24.72 24.72 0 1 1 49.1 4.06h35.34a24.72 24.72 0 1 1 49.1-4.06 25.77 25.77 0 0 1-.33 4.06H291a24.72 24.72 0 1 1 48.76 0h33.8a25.77 25.77 0 0 1-.33-4.06 24.72 24.72 0 1 1 48.41 7.06l26.85 38.1c7.38 0 9.39-1.86 9.36-9.32q-.15-34.19-.16-68.37c-5.84-6-33.16-47-66.82-99.17A24.74 24.74 0 0 1 373.24 316zM144.6 424.51a24.72 24.72 0 1 1 24.71-24.72 24.72 24.72 0 0 1-24.71 24.72zm0-83.78A24.72 24.72 0 1 1 169.31 316a24.72 24.72 0 0 1-24.71 24.73zm0-86.88a24.72 24.72 0 1 1 24.71-24.72 24.72 24.72 0 0 1-24.71 24.72zm0-86.7a24.72 24.72 0 1 1 24.71-24.72 24.72 24.72 0 0 1-24.71 24.72zm84.1 257.36a24.72 24.72 0 1 1 24.72-24.72 24.71 24.71 0 0 1-24.72 24.72zm0-83.78A24.72 24.72 0 1 1 253.42 316a24.71 24.71 0 0 1-24.72 24.73zm0-86.88a24.72 24.72 0 1 1 24.72-24.72 24.71 24.71 0 0 1-24.72 24.72zm0-86.7a24.72 24.72 0 1 1 24.72-24.72 24.71 24.71 0 0 1-24.72 24.72zm86.69 257.36a24.72 24.72 0 1 1 24.72-24.72 24.72 24.72 0 0 1-24.72 24.72zm0-83.78A24.72 24.72 0 1 1 340.11 316a24.72 24.72 0 0 1-24.72 24.73zm107.28 59.06A24.72 24.72 0 1 1 398 375.07a24.71 24.71 0 0 1 24.67 24.72zM448.47 83.14l-64.15.09c23.31 0 45.41 0 64.28-.09zM292 550.74q-19.18-.13-38.35 0c-3.88 0-6.66 1.77-6.82 6.08-.18 4.75 2.62 6.78 7 6.86 6.23.13 12.47 0 18.71 0 6.55 0 13.1.08 19.64 0 3.87-.08 6.66-1.83 6.84-6.1.13-4.75-2.73-6.81-7.02-6.84zM270.36 40.73c5.7-.07 8.74-4 9.55-9.62-.87-5.59-4-9.44-9.65-9.55s-9.56 3.53-9.74 9.19c-.2 6.16 3.72 10.06 9.84 9.98z",
    fill: "#6e5f91"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M449.63 83.14h-1c-18.87 0-41 .07-64.28.09-39.9 0-83.32.07-120.09.08H234.4c-3.25 0 30 55.58 71.87 122.84a24.72 24.72 0 0 1 25.8 41.22c13.79 21.9 27.88 44.09 41.41 65.24A24.71 24.71 0 1 1 398 340.73a25 25 0 0 1-7.08-1c33.66 52.17 61 93.17 66.82 99.17.75.78 1.16 1 1.15.53q-.08-69.78 0-139.57c0-69.13-.13-138.27.17-207.41.01-7.55-2.06-9.32-9.43-9.31zm-134.24 84a24.72 24.72 0 1 1 24.72-24.72 24.72 24.72 0 0 1-24.72 24.73zM398 253.85a24.72 24.72 0 1 1 24.71-24.72A24.72 24.72 0 0 1 398 253.85zm0-86.7a24.72 24.72 0 1 1 24.71-24.72A24.72 24.72 0 0 1 398 167.15z",
    fill: "#f4abe0"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.6,
    cy: 142.43,
    r: 24.72,
    fill: "#f0592b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M228.7 117.71a24.72 24.72 0 1 0 24.72 24.72 24.71 24.71 0 0 0-24.72-24.72z",
    fill: "#fdb73e"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 315.39,
    cy: 142.43,
    r: 24.72,
    fill: "#6ab4e5"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 397.96,
    cy: 142.43,
    r: 24.72,
    fill: "#b7a2cc"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.6,
    cy: 229.13,
    r: 24.72,
    fill: "#f4abe0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M228.7 204.41a24.72 24.72 0 1 0 24.72 24.72 24.71 24.71 0 0 0-24.72-24.72z",
    fill: "#93b847"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M290.67 229.13a24.71 24.71 0 1 0 15.6-23 24.72 24.72 0 0 0-15.6 23z",
    fill: "#b7a2cc"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 397.96,
    cy: 229.13,
    r: 24.72,
    fill: "#f0592b"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.6,
    cy: 316.01,
    r: 24.72,
    fill: "#6ab4e5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M228.7 291.29A24.72 24.72 0 1 0 253.42 316a24.71 24.71 0 0 0-24.72-24.71z",
    fill: "#f0592b"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 315.39,
    cy: 316.01,
    r: 24.72,
    fill: "#16a99e"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M390.88 339.7a25 25 0 0 0 7.08 1 24.72 24.72 0 1 0-24.48-28.12 23.77 23.77 0 0 0-.24 3.4 24.74 24.74 0 0 0 17.64 23.72z",
    fill: "#b7a2cc"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.6,
    cy: 399.79,
    r: 24.72,
    fill: "#16a99e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M228.7 375.07a24.72 24.72 0 1 0 24.72 24.72 24.71 24.71 0 0 0-24.72-24.72z",
    fill: "#d6842d"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 315.39,
    cy: 399.79,
    r: 24.72,
    fill: "#f4abe0"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 397.96,
    cy: 399.79,
    r: 24.72,
    fill: "#b7a2cc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M421.65 478.45a24.72 24.72 0 0 1-48.08-3h-33.8a24.71 24.71 0 0 1-48.76 0h-37.92a24.72 24.72 0 0 1-48.77 0H169a24.72 24.72 0 0 1-48.77 0h-1.43l-25.71 41.1H448.5z",
    fill: "#b7a2cc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M144.6 496.11a24.72 24.72 0 1 0-24.72-24.72 25.77 25.77 0 0 0 .33 4.06 24.73 24.73 0 0 0 24.39 20.66z",
    fill: "#fdb73e"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M228.7 496.11a24.73 24.73 0 0 0 24.39-20.66 25.77 25.77 0 0 0 .33-4.06 24.72 24.72 0 1 0-24.72 24.72z",
    fill: "#f0592b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M315.39 496.11A24.75 24.75 0 1 0 291 475.45a24.71 24.71 0 0 0 24.39 20.66z",
    fill: "#6ab4e5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M398 496.11a24.72 24.72 0 1 0-24.72-24.72 25.77 25.77 0 0 0 .33 4.06A24.73 24.73 0 0 0 398 496.11z",
    fill: "#93b847"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M580.6 191.23c-2.58 0-25.79-.86-25.79-27.94a2.79 2.79 0 1 0-5.58 0c0 27.08-23.21 27.94-25.79 27.94h-.22a2.8 2.8 0 0 0-2.58 2.79 2.85 2.85 0 0 0 2.8 2.79c2.79 0 25.79.86 25.79 27.94a2.84 2.84 0 0 0 2.79 2.79 2.47 2.47 0 0 0 2.58-2.54c0-27.08 23.21-27.93 25.79-27.93h.21a2.9 2.9 0 0 0 2.8-3 2.84 2.84 0 0 0-2.8-2.84z",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTablets, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tablets.92e7b24a.svg";
export { ForwardRef as ReactComponent };